import edmImage from "../assets/styles/style-edm.svg";
import hiphopImage from "../assets/styles/style-hip-hop.svg";
import instrumentalImage from "../assets/styles/style-instrumental.svg";
import popImage from "../assets/styles/style-pop.svg";
import rockImage from "../assets/styles/style-rock.svg";
import universalImage from "../assets/styles/style-universal.svg";

import { StylePreset } from "../../model/Mastering";

const stylePresetMapping: Record<
    StylePreset,
    { label: string; image?: string }
> = {
    POP: { label: "Pop", image: popImage },
    ROCK: { label: "Rock", image: rockImage },
    HIPHOP: { label: "Hip-Hop", image: hiphopImage },
    EDM: { label: "EDM", image: edmImage },
    UNIVERSAL: { label: "Universal", image: universalImage },
    INSTRUMENTAL: { label: "Instrumental", image: instrumentalImage },
    REFERENCE_TRACK: { label: "Reference track" },
};

export default stylePresetMapping;
